import { jsx as _jsx } from "react/jsx-runtime";
import { Menu, useTheme } from '@mui/material';
import { MagicStar } from 'iconsax-react';
import ReassignPickupLocationMini from './ReassignPickupLocationMini';
const ReassignPickupLocationMenu = ({ anchorEl, open, onClose, options, onSelect, eventIcon, onSearchChange }) => {
    const theme = useTheme();
    return (_jsx(Menu, { anchorEl: anchorEl, open: open, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        }, MenuListProps: {
            sx: { p: 0 }
        }, PaperProps: {
            sx: {
                mt: 1,
                borderRadius: 2,
                boxShadow: '0px 8px 24px rgba(145,158,171,0.24)'
            }
        }, children: _jsx(ReassignPickupLocationMini, { options: options, eventIcon: eventIcon ?? (_jsx(MagicStar, { variant: 'Outline', size: 16, color: theme.palette.text.secondary })), onSelect: (location) => {
                onSelect(location);
                onClose();
            }, onSearchChange: onSearchChange }) }));
};
export default ReassignPickupLocationMenu;
